import { FormControl, FormGroup, Validators } from '@angular/forms';

export function createLegalCheckForm(): FormGroup<GarantieLegalCheckFormModel> {
  return new FormGroup<GarantieLegalCheckFormModel>({
    hasAgreedToElectronicCommunication: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcceptedPrivacyPolicy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcceptedGeneralTermsAndConditions: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasReadInsuranceProductInformationSheet: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAuthorizedSepaDirectDebit: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasAcknowledgedRightOfWithdrawal: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.requiredTrue] }),
    hasConfirmedProductMeetsWishesAndNeeds: new FormControl<boolean>(false, {
      nonNullable: true,
      validators: [Validators.requiredTrue]
    })
  });
}

export interface GarantieLegalCheckFormModel {
  hasAgreedToElectronicCommunication: FormControl<boolean>;
  hasAcceptedPrivacyPolicy: FormControl<boolean>;
  hasAcceptedGeneralTermsAndConditions: FormControl<boolean>;
  hasReadInsuranceProductInformationSheet: FormControl<boolean>;
  hasAuthorizedSepaDirectDebit: FormControl<boolean>;
  hasAcknowledgedRightOfWithdrawal: FormControl<boolean>;
  hasConfirmedProductMeetsWishesAndNeeds: FormControl<boolean>;
}
